import React, { useContext } from "react";

import "../styles/Chart.css";
import { ActionTypes } from "../constants";
import { HandCombosContext, PlayerSelectedContext } from "../context/store";
import { getNutFlushDraws, getBDNFD, getPP } from "../utils/combinations";

export function AddCombosButtons(props) {
  // This only ADDS combos, does not remove.
  const [selectedCombos, handleSelectedDispatch] = useContext(
    HandCombosContext
  );
  const [playerSelected, handleButtonDispatch] = useContext(
    PlayerSelectedContext
  );
  function handleAnyNFD(e) {
    // TODO: Wire this up correctly
    handleSelectedDispatch({
      type: ActionTypes.UPDATE_MANY_COMBOS,
      player: playerSelected,
      newCombos: getNutFlushDraws(selectedCombos["board"])
    });
  }
  function handleBDNFD(e) {
    handleSelectedDispatch({
      type: ActionTypes.UPDATE_MANY_COMBOS,
      player: playerSelected,
      newCombos: getBDNFD(selectedCombos["board"])
    });
  }
  function handlePP(e) {
    handleSelectedDispatch({
      type: ActionTypes.UPDATE_MANY_COMBOS,
      player: playerSelected,
      newCombos: getPP()
    });
  }
  const buttonStyle = {
    display: "grid",
    gridTemplateRows: "repeat(3, minmax(0, 1fr))",
    minWidth: "0%",
    minHeight: "0%",
    gridRowGap: "5px"
  };
  return (
    <div style={buttonStyle}>
      <button className="button railButton" onClick={handlePP}>
        Add Pocket Pairs
      </button>
      <button className="button railButton" onClick={handleAnyNFD}>
        Add Ace high flush draws
      </button>
      <button className="button railButton" onClick={handleBDNFD}>
        Add backdoor Ace high flush draws
      </button>
    </div>
  );
}
